import MapViewItemType from '../../../enums/MapViewItemType'
import { ALLOWED_SITEMAP_ITEMS_WITHOUT_DATA_OBJECT } from '../../MapBoxViewer/mapboxConstants'

/**
 * Whether a drawn item may exist with no location behind it: only a drawing primitive may, because
 * it never had one to lose. Anything else dataless has lost its location, and staying invisible is
 * how that gets noticed — STX1-881 shipped integration locations in the JHP snapshot for exactly
 * that reason.
 */
export const canRenderWithoutDataObject = (item: {
  type: MapViewItemType
}): boolean => ALLOWED_SITEMAP_ITEMS_WITHOUT_DATA_OBJECT.includes(item?.type)
